const dialogs = document.querySelectorAll('dialog');

dialogs.forEach((dialog) => {
    const scrollable = dialog.querySelector('.dialog-content');
    const form = dialog.querySelector('form.wpcf7-form');
    form?.addEventListener('wpcf7submit', (e) => {
        setTimeout(() => {
            scrollable?.scrollTo(0, scrollable.scrollHeight);
        }, 1000);
    });
});
